<template>
  <div>
    <div v-if="loading">
      <v-progress-linear
        indeterminate
        color="primary"
        class="mb-0"
      />
    </div>
    <v-card-text style="height: 300px; overflow: auto;">
      <div class="px-6 py-4">
        <div v-if="error"> 
          {{ errorMsg }}
        </div>
        <div v-else v-html="message"></div>
      </div>
    </v-card-text>
  </div>
</template>
<script>
export default {
  name: "MessageDetail",
  props: ["messageId"],
  data() {
    return {
      rawMessage: "",
      message: "",
      loading: true,
      error: false,
    }    
  },
  mounted() {
    // const body = { id_notification: this.messageId };
    // this.$axios.post(`/player/notifications/getNotification`, this.$formdata(body))
    // .then((res) => {
    //   this.error = false;
    //   this.message = res.data.dados.message;
    // })
    // .catch((err) => {
    //   this.errorMsg = err.response.data.messages.error;
    //   this.error = true;
    // })
    // .finally(() => this.loading = false);
    this.fetchMessage();
    
  },

  methods: {
    fetchMessage() {
      const body = { id_notification: this.messageId };
      this.$axios.post(`/player/notifications/getNotification`, this.$formdata(body))
      .then((res) => {
        this.error = false;
        this.rawMessage = res.data.dados.message;
        this.message = this.convertLinksToClickable(this.rawMessage);
      })
      .catch((err) => {
        this.errorMsg = err.response.data.messages.error;
        this.error = true;
      })
      .finally(() => this.loading = false);
    },

    convertLinksToClickable(text) {
      // para verificar se o link tem https:// no início
      const httpsRegex = /^https?:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/i; //eslint-disable-line

      // para verificar se existe algum link no texto
      const urlRegex = /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/g; //eslint-disable-line

      // Tratamento para envolver o link em tags <a></a>
      const clickableText = text.replace(urlRegex, (match) => {
        // se o link não tiver https:// no início,
        // insere, isso evita bug no redirecionamento
        if (!httpsRegex.test(match)) {
          return `<a href="https://${match}" target="_blank">${match}</a>`;
        }

        return `<a href="${match}" target="_blank">${match}</a>`;
      });

      return clickableText;
    }
  }
}
</script>